// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../areIntervalsOverlapping/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var areIntervalsOverlapping = convertToFP(fn, 2);
export default areIntervalsOverlapping;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/areIntervalsOverlapping/index.js
// module id = 820
// module chunks = 0